<template>
    <div class="container-fluid">
        <div class="d-flex p-2 justify-content-center align-items-center">
            <i v-if="loadRemove" style="margin: 0 auto;font-size: 40px;"
               class="fas fa-circle-notch fa-spin"></i>
            <div v-if="removed">

                <h1 class="text-center">
                    <font-awesome-icon :icon="['fas', 'blender-phone']"/>
                    <span style="font-size: 40px !important;">QuickLy</span></h1>

                <div class="row">
                    <div class="shadow-lg p-5 mb-5 bg-white rounded" style="color: #8d8d8d">
                        <div class="text-center mt-3">
                            <span style="font-size: 20px !important;">{{$t('canceled_appointement')}}<br/>{{$t('choose_another_appointment')}} <a
                                    :href="pathToEvent">{{$t('click here')}}</a></span>
                        </div>
                    </div>
                </div>

                <p style="font-size: 11px;text-align: center;color: #7b7b7b;">by <a href="https://greenbull.group/"
                                                                                    target="_blank"
                                                                                    style="color:#7b7b7b;font-style: italic;">GreenBull
                    Group</a></p>
            </div>

            <div v-if="problem">
                <h1 class="text-center">
                    <font-awesome-icon :icon="['fas', 'blender-phone']"/>
                    <span style="font-size: 40px !important;">QuickLy</span></h1>

                <div class="row">
                    <div class="shadow-lg p-5 mb-5 bg-white rounded text-danger" style="color: #8d8d8d">
                        <div class="text-center mt-3">
                            <span style="font-size: 16px !important;"><strong>{{$t('error_canceling_appointement')}}</strong><br/>{{$t('try_again_support')}}</span>
                        </div>
                    </div>
                </div>

                <p style="font-size: 11px;text-align: center;color: #7b7b7b;">by <a href="https://greenbull.group/"
                                                                                    target="_blank"
                                                                                    style="color:#7b7b7b;font-style: italic;">GreenBull
                    Group</a></p>
            </div>

            <!-- Modal -->
            <div v-if="showModal">
                <h1 class="text-center">
                    <font-awesome-icon :icon="['fas', 'blender-phone']"/>
                    <span style="font-size: 40px !important;">QuickLy</span></h1>

                <div class="row">
                    <div class="shadow-lg p-5 mb-5 bg-white rounded" style="color: #8d8d8d">
                        <div class="text-center mt-3">
                            <span style="font-size: 16px !important;"><strong>{{$t('cancel_appointment_question')}}</strong></span>
                        </div>
                        <div class="mt-5 float-right">
                            <button type="button" class="btn btn-light mr-2" data-dismiss="modal"
                                    v-on:click="stopCancelMeeting()">{{$t('Cancel')}}
                            </button>
                            <button type="button" class="btn" style="background-color: #9ac455; color: #fff;"
                                    v-on:click="cancelMeetingConfirmed()">{{$t('Confirm')}}
                            </button>
                        </div>
                    </div>
                </div>

                <p style="font-size: 11px;text-align: center;color: #7b7b7b;">by <a href="https://greenbull.group/"
                                                                                    target="_blank"
                                                                                    style="color:#7b7b7b;font-style: italic;">GreenBull
                    Group</a></p>
            </div>

        </div>
    </div>

</template>
<script>
    import axios from 'axios';
    import {api, cognitoCredentials, cognitoApp} from '../../config';

    export default {
        data() {
            return {
                pathToEvent: "",
                removed: false,
                loadRemove: false,
                problem: false,
                showModal: true,
                cognitoCredentials: cognitoCredentials,
                cognitoApp: cognitoApp,
                accessToken: ""
            }
        },
        created() {
            this.getCognitoAccessToken();
            this.$i18n.locale = this.$route.params.lang != null ? this.$route.params.lang : "fr";
        },
        methods: {
            stopCancelMeeting() {
                this.showModal = false;
                this.$router.push("/" + this.$route.params.slug);
            },
            cancelMeetingConfirmed() {
                this.showModal = false;
                this.loadRemove = true;
                this.pathToEvent = "/" + this.$route.params.slug
                axios.get(api.url + 'event/remove/' + this.$route.params.itemId + "/" + this.$route.params.eventId, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.accessToken
                    }
                })
                    .then(response => {
                        this.loadRemove = false;
                        this.removed = true;
                        this.problem = false;
                        if (response.data == "again") {
                            this.$router.push(this.pathToEvent)
                        }
                    })
                    .catch(error => {
                        this.removed = false;
                        this.loadRemove = false;
                        this.problem = true;
                        return error;
                    })
            },
            getCognitoAccessToken() {
                axios.post(this.cognitoApp, '',
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'AuthFlow': 'REFRESH_TOKEN_AUTH'
                        },
                        auth: this.cognitoCredentials
                    })
                    .then(response => {
                        this.accessToken = response.data.access_token;
                    })
                    .catch(error => {
                        console.log(error);
                        return error;
                    })
            }
        },
        name: 'Canceled'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
